/**
 * Badges de notifications :
 *  - titre de l'onglet `(n) Mon CV Pro`
 *  - badge natif de l'icône d'application (navigator.setAppBadge, PWA)
 */
export const updateNotificationBadges = (count: number) => {
  document.title = count > 0 ? `(${count}) Mon CV Pro` : "Mon CV Pro";

  if ("setAppBadge" in navigator) {
    try {
      if (count > 0) {
        navigator.setAppBadge(count);
      } else {
        navigator.clearAppBadge();
      }
    } catch {
      // Badge non supporté (navigateurs sans Badging API) — silencieux
    }
  }
};
